import { Config } from "../Config";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

import {
  getDatabase,
  ref,
  set,
  onValue,
  query,
  orderByChild,
  orderByValue,
  orderByKey,
  endAt,
  equalTo,
  startAt,
  push,
  child,
  update,
  limitToLast,
  increment,
  get,
  connectDatabaseEmulator,
  remove,
  off,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  forceWebSockets,
  startAfter,
} from "firebase/database";

import {
  doc,
  getDoc,
  setDoc,
  getFirestore,
  updateDoc,
  arrayUnion,
  arrayRemove,
  onSnapshot,
  connectFirestoreEmulator,
  collection,
  query as storeQuery,
  where,
  limit,
  getDocs,
  deleteDoc,
  deleteField,
  orderBy,
  addDoc,
  getCountFromServer,
} from "firebase/firestore";

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateEmail,
  reauthenticateWithCredential,
  GoogleAuthProvider,
  signInWithRedirect,
  signInAnonymously,
  linkWithCredential,
  linkWithRedirect,
  connectAuthEmulator,
  signInWithPopup,
  getRedirectResult,
  applyActionCode,
  checkActionCode,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from "firebase/auth";

import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from "firebase/functions";

import {
  connectStorageEmulator,
  getDownloadURL,
  getBlob,
  getStorage,
  ref as storageRef,
  uploadBytes,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";

import {
  getRemoteConfig,
  getValue,
  fetchAndActivate,
  getAll,
} from "firebase/remote-config";
import { idMaker } from "./functions";

const uri = new URL(window.location.href);
let config = "";
if (uri.hostname.match("100ninkaigi.jp")) {
  config = Config.prod;
} else if (uri.hostname.match("100ninkaigi.live")) {
  config = Config.dev;
} else {
  config = Config.local;
}

const appCheckSiteKey = {
  prod: "6LdTL3UnAAAAAKAw91zwEWiPv2PqsaDZttCHweh1",
  dev: "6LfFNnQnAAAAAPtCePKA5SuGA3OXfCzyKWCh2LKD",
  local: "6LflZXQnAAAAAMTNsLiYvbllWift4lfoup5dvADC",
};

let myEnv = "";
if (uri.hostname.match("100ninkaigi.jp")) {
  myEnv = "prod";
} else if (uri.hostname.match("100ninkaigi.live")) {
  myEnv = "dev";
} else {
  myEnv = "local";
}

export const projApp = initializeApp(config);
// const analytics = getAnalytics(projApp);
const firestore = getFirestore(projApp);
const database = getDatabase(projApp);
const auth = getAuth(projApp);
const storage = getStorage(projApp);
const functions = getFunctions(projApp);
functions.region = "asia-northeast1";

// ロングポーリングを使用すると、データベースに接続できないことがあるため無効にする
forceWebSockets();
// ロングポーリングに失敗した時にlocalStorageに保存されるので削除する
localStorage.removeItem("firebase:previous_websocket_failure");


// if (myEnv !== "prod") {
//   self.FIREBASE_APPCHECK_DEBUG_TOKEN = "746014ea-8766-407c-8cc0-5e0c4c565332";
// }

// const appCheck = initializeAppCheck(projApp, {
//   provider: new ReCaptchaV3Provider(appCheckSiteKey[myEnv]),

//   // Optional argument. If true, the SDK automatically refreshes App Check
//   // tokens as needed.
//   isTokenAutoRefreshEnabled: true,
// });

const EMULATORS_STARTED = "EMULATORS_STARTED";
function startEmulators() {
  if (!global[EMULATORS_STARTED]) {
    global[EMULATORS_STARTED] = true;
    connectFunctionsEmulator(functions, "localhost", 5001);
    // connectAuthEmulator(auth, "http://localhost:9099");
    connectFirestoreEmulator(firestore, "localhost", 8080);
    // connectDatabaseEmulator(database, "localhost", 9000);
    connectStorageEmulator(storage, "localhost", 9199);
  }
}

if (Config.isEmulating) {
  console.log("emu connect");
  startEmulators();
  // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  // // connectAuthEmulator(auth, "http://127.0.0.1:9099");
  // connectFirestoreEmulator(firestore, "127.0.0.1", 8080);
  // // connectDatabaseEmulator(database, "127.0.0.1", 9000);
  // connectStorageEmulator(storage, "127.0.0.1", 9199);
}

export const replaceForbiddenKey = (str) => {
  const replacements = {
    ".": "<dot>",
    "#": "<sharp>",
    $: "<dollar>",
    "/": "<slash>",
    "[": "<bracket-l>",
    "]": "<bracket-r>",
  };

  const result = str.replace(/\.|#|\$|\/|\[|\]/g, function (matched) {
    return replacements[matched];
  });

  return result;
};

export const replaceForbiddenKeyBack = (str) => {
  const replacements = {
    "<dot>": ".",
    "<sharp>": "#",
    "<dollar>": "$",
    "<slash>": "/",
    "<bracket-l>": "[",
    "<bracket-r>": "]",
  };

  const result = str.replace(
    /<dot>|<sharp>|<dollar>|<slash>|<bracket-l>|<bracket-r>/g,
    function (matched) {
      return replacements[matched];
    }
  );

  return result;
};


/*---------------------------------

  汎用関数

---------------------------------*/

export const createDocRef = (collectionName) => {
  const collectionRef = collection(firestore, collectionName);
  const docRef = doc(collectionRef);
  return docRef;
};

export function functionCall(functionPath, body) {
  const calledFunction = httpsCallable(functions, functionPath);
  return calledFunction(body);
}

export function onceGetDb(path) {
  return get(child(ref(database), path))
    .then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return null;
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

export function writeDb(path, data) {
  return set(ref(database, path), data);
}

export function updatesDb(updates) {
  return update(ref(database), updates);
}

export function pushDb(path, data) {
  const newDataRef = push(child(ref(database), path));
  update(newDataRef, data);
}

export const deleteDb = (path) => {
  return remove(ref(database, path));
};

export function listenDb(path, setterFuc) {
  const pathRef = ref(database, path);
  return onValue(pathRef, (snapshot) => {
    if (snapshot.val()) {
      setterFuc(snapshot.val());
    } else {
      setterFuc({});
    }
  });
}

export const queryDb = (path, queryKey = "", queryValue = "", limit = 100) => {
  let pathRef = query(
    ref(database, path),
    orderByChild(queryKey),
    equalTo(queryValue),
    limitToLast(limit)
  );

  return get(pathRef).then((snapshot) => {
    return snapshot?.val();
  });
};

export function queryListenDb(
  path,
  setterFuc,
  queryKey,
  queryValue,
  limit = 100,
  event = "value"
) {
  const pathRef = query(
    ref(database, path),
    orderByChild(queryKey),
    equalTo(queryValue),
    limitToLast(limit)
  );

  switch (event) {
    case "value":
      return onValue(pathRef, (snapshot) => {
        if (snapshot.val()) {
          setterFuc(snapshot.val());
        } else {
          setterFuc({});
        }
      });
    case "child_added":
      return onChildAdded(pathRef, (snapshot) => {
        if (snapshot.val()) {
          setterFuc(snapshot.val());
        } else {
          setterFuc({});
        }
      });
    case "child_changed":
      return onChildChanged(pathRef, (snapshot) => {
        if (snapshot.val()) {
          setterFuc(snapshot.val());
        } else {
          setterFuc({});
        }
      });
    case "child_removed":
      return onChildRemoved(pathRef, (snapshot) => {
        if (snapshot.val()) {
          setterFuc(snapshot.val());
        } else {
          setterFuc({});
        }
      });
  }
}

export function getDb(path, limit = 100) {
  let pathRef = query(ref(database, path), orderByKey(), limitToLast(limit));
  return get(pathRef)
    .then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return 0;
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

export function getDbFromA(path, lastUnix, mode, limit = 100) {
  let pathRef;
  if (mode === "before") {
    pathRef = query(
      ref(database, path),
      orderByKey(),
      endAt(lastUnix),
      limitToLast(limit)
    );
  } else {
    pathRef = query(
      ref(database, path),
      orderByKey(),
      startAt(lastUnix),
      limitToLast(limit)
    );
  }
  return get(pathRef)
    .then((snapshot) => {
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return 0;
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

export function queryListenChatListDb(path, setterFuc, queryValue) {
  const pathRef = query(
    ref(database, path),
    orderByChild(queryValue),
    startAt(-1)
  );
  return onValue(pathRef, (snapshot) => {
    if (snapshot.val()) {
      setterFuc(snapshot.val());
    }
  });
}


// 変更を監視する
/**
 * このリスナー単体でデタッチできるver
 * setterFuncではsnapshotから値を取得するようにする
 * @param {*} path 
 * @param {*} setterFuc 
 * @param {*} limit 
 * @returns 
 * @example  const path = `${getUrlParam(1)}/questionStatus/${getUrlParam(
      2
    )}/${getUrlParam(3)}`;
    const handler = (snapshot) => {
      var value = snapshot.val();
      setactiveQuizId(value.activeQuiz);
    };

    listenDbV2(path, handler);

    return () => {
      offListenDb(path, handler);
    };
 */
export function listenDbV2(path, setterFuc, limit: number | null = null, event = "value") {
  let pathRef = ref(database, path);
  if (limit) {
    pathRef = query(pathRef, limitToLast(limit));
  }

  switch (event) {
    case "value":
      return onValue(pathRef, (snapshot) => {
        if (snapshot) {
          setterFuc(snapshot);
        } else {
          setterFuc({});
        }
      });
    case "child_added":
      return onChildAdded(pathRef, (snapshot) => {
        if (snapshot) {
          setterFuc(snapshot);
        } else {
          setterFuc({});
        }
      });
    case "child_changed":
      return onChildChanged(pathRef, (snapshot) => {
        if (snapshot) {
          setterFuc(snapshot);
        } else {
          setterFuc({});
        }
      });
    case "child_removed":
      return onChildRemoved(pathRef, (snapshot) => {
        if (snapshot) {
          setterFuc(snapshot);
        } else {
          setterFuc({});
        }
      });
  }
}


export function listenLimitDb(path, setterFuc, limit = 10) {
  const pathRef = query(ref(database, path), limitToLast(limit));
  return onValue(pathRef, (snapshot) => {
    if (snapshot.val()) {
      setterFuc(snapshot.val());
    }
  });
}

/**
 * リスナーをデタッチできるver
 * setterFucを丸ごと渡さないとリスナーごとにデタッチできないため
 * @param {*} path
 * @param {*} setterFuc
 * @param {*} limit
 * @returns
 */
export function listenChildSizeV2(path, setterFuc, limit = null) {
  var pathRef = ref(database, path);
  if (limit) {
    pathRef = query(pathRef, limitToLast(limit));
  }

  return onValue(pathRef, (snapshot) => {
    if (snapshot.val()) {
      // modulerとnamaspaceでプロパティが変わるので、注意
      setterFuc(snapshot.size);
    }
  });
}

export function offListenDb(path) {
  off(ref(database, path));
}

export function offListenDbV2(path, listener = null, type = "value") {
  var _ref = ref(database, path);
  if (listener) {
    off(_ref, type, listener);
  } else {
    off(_ref, type);
  }
}


/*---------------------------------

  Firestore

---------------------------------*/

export declare type StoreQueries = {
  method: string;
  args: any[];
}[];

const createStoreQuery = (args: StoreQueries) => {
  const query = args.map((arg) => {
    if (arg.method === "where") {
      return where(...arg.args);
    }
    if (arg.method === "orderBy") {
      return orderBy(...arg.args);
    }
    if (arg.method === "limit") {
      return limit(...arg.args);
    }
    if (arg.method === "startAfter") {
      return startAfter(...arg.args);
    }
  })

  return query;
}

const switchQueryArgs = (collectionRef, args) => {
  let q;
  if (args?.[0]?.method) {
    q = storeQuery(collectionRef, ...createStoreQuery(args));
  } else {
    q = storeQuery(collectionRef, ...args);
  }
  return q;
}

type QueryReturnType = "data" | "count" | "snapshots";


export async function getStore(path) {
  const docRef = doc(firestore, path);
  return getDoc(docRef).then((docSnap) => {
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      return {};
    }
  });
}

export function setStore(path, data) {
  return setDoc(doc(firestore, path), data, { merge: true });
}

export const addStore = async (collectionPath, data) => {
  const collectionRef = collection(firestore, collectionPath);
  const docRef = doc(collectionRef);
  await setDoc(docRef, {
    id: docRef.id,
    ...data,
  });
  return docRef.id;
};

export function updateStore(path, data) {
  return updateDoc(doc(firestore, path), data);
}

export function deleteNestStore(path, key) {
  return updateDoc(doc(firestore, path), { [key]: deleteField() });
}

export function deleteNestMultiStore(path, keys) {
  let obj = {};
  keys.forEach((key) => {
    obj[key] = deleteField();
  });
  return updateDoc(doc(firestore, path), obj);
}

export async function addUnionStore(path, key, data) {
  const docRef = doc(firestore, path);
  await updateDoc(docRef, {
    [key]: arrayUnion(data),
  });
}

export async function removeUnionStore(path, key, data) {
  const docRef = doc(firestore, path);
  await updateDoc(docRef, {
    [key]: arrayRemove(data),
  });
}

export async function singleQueryStore(
  path,
  key = "",
  ope = "",
  value = "",
  limitNum = 2,
  orderByKey = "",
  orderBySort = ""
) {
  const collectionRef = collection(firestore, path);
  let q;
  if (key !== "") {
    if (orderByKey !== "") {
      q = storeQuery(
        collectionRef,
        where(key, ope, value),
        limit(limitNum),
        orderBy(orderByKey, orderBySort)
      );
    } else {
      q = storeQuery(collectionRef, where(key, ope, value), limit(limitNum));
    }
  } else {
    if (orderByKey !== "") {
      q = storeQuery(
        collectionRef,
        limit(limitNum),
        orderBy(orderByKey, orderBySort)
      );
    } else {
      q = storeQuery(collectionRef, limit(limitNum));
    }
  }
  const querySnapshot = await getDocs(q);
  let tmp = [];
  querySnapshot.forEach((queriedDoc) => {
    tmp.push(queriedDoc.data());
  });
  return tmp;
}

export async function queryStore(
  path,
  key = "",
  ope = "",
  value = "",
  key2 = "",
  ope2 = "",
  value2 = "",
  key3 = "",
  ope3 = "",
  value3 = "",
  key4 = "",
  ope4 = "",
  value4 = ""
) {
  const collectionRef = collection(firestore, path);
  let q;
  if (key !== "") {
    if (key2 !== "") {
      if (key3 !== "") {
        if (key4 !== "") {
          q = storeQuery(
            collectionRef,
            where(key, ope, value),
            where(key2, ope2, value2),
            where(key3, ope3, value3),
            where(key4, ope4, value4)
          );
        } else {
          q = storeQuery(
            collectionRef,
            where(key, ope, value),
            where(key2, ope2, value2),
            where(key3, ope3, value3)
          );
        }
      } else {
        q = storeQuery(
          collectionRef,
          where(key, ope, value),
          where(key2, ope2, value2)
        );
      }
    } else {
      q = storeQuery(collectionRef, where(key, ope, value));
    }
  } else {
    q = collectionRef;
  }
  const querySnapshot = await getDocs(q);
  let tmp = [];
  querySnapshot.forEach((queriedDoc) => {
    tmp.push(queriedDoc.data());
  });
  return tmp;
}


/**
 * @example queryStoreV2(
          `hotel/${hotelCodeContext}/calendarStock/${doc.id}/bookingStock`,
          [where('netRoomTypeGroupId', '==', currentNetRoomTypeGroup.id)],
          'count'
        );
 * @param path 
 * @param args 
 * @param returnType 
 * @returns 
 */
export async function queryStoreV2(
  path: string,
  args: StoreQueries = [],
  returnType: QueryReturnType = "data"
) {

  const collectionRef = collection(firestore, path);
  const q = switchQueryArgs(collectionRef, args);
  const tmp = [];

  if (returnType === "data") {
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((queriedDoc) => {
      tmp.push(queriedDoc.data());
    });
  } else if (returnType === "count") {
    const querySnapshot = await getCountFromServer(q);
    return querySnapshot.data().count;
  } else if (returnType === "snapshots") {
    const querySnapshot = await getDocs(q);
    return querySnapshot;
  }

  return tmp;
}

export function queryListenStore(
  path,
  setFunc,
  key = "",
  ope = "",
  value = ""
) {
  const collectionRef = collection(firestore, path);
  let q;
  if (key !== "") {
    q = storeQuery(collectionRef, where(key, ope, value));
  } else {
    q = collectionRef;
  }
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const dataArr = [];
    querySnapshot.forEach((docu) => {
      dataArr.push(docu.data());
    });
    setFunc(dataArr);
  });
  return unsubscribe;
}

export function queryListenStoreV2(path, setFunc, args: any[] = [], returnType: QueryReturnType = "data") {
  const collectionRef = collection(firestore, path);
  const q = switchQueryArgs(collectionRef, args);

  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    if (returnType === "data") {
      const dataArr = [];
      querySnapshot.forEach((doc) => {
        dataArr.push(doc.data());
      });
      setFunc(dataArr);
    } else if (returnType === "snapshots") {
      setFunc(querySnapshot);
    }
  });
  return unsubscribe;
}



/**
 * 配列を指定したサイズで分割する
 * @param {Array} array - 分割する配列
 * @param {number} chunkSize - 分割するサイズ
 * @example 
 * inなどの配列メンバーのqueryの上限は30なので、検索対象文字列の配列を30個ずつに分割する
*  const splitArr = splitArrayIntoChunks(ids, 30);
*       splitArr.map((arr) => {
      return queryStoreV2('collectionName', where('id', 'in', arr));
    });
 * @see https://firebase.google.com/docs/firestore/query-data/queries?hl=ja#query_limitations
 * */
export const splitArrayIntoChunks = (array, chunkSize = 30) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

export const splitArrayQueryStore = (
  collectionName: string,
  key: string,
  targetArr: string[],
  args = []
) => {
  const splitArr = splitArrayIntoChunks(targetArr);

  return Promise.all(
    splitArr.map((arr) => {
      return queryStoreV2(collectionName, [where(key, "in", arr), ...args]);
    })
  ).then((res) => {
    const flatArr = res.flat();
    return flatArr;
  });
};

export async function deleteStore(path) {
  await deleteDoc(doc(firestore, path));
}

export async function incrementStore(path, key) {
  const docRef = doc(firestore, path);
  try {
    await updateDoc(docRef, { [key]: increment(1) });
  } catch (error) {
    setDoc(docRef, { [key]: increment(1) }, { merge: true });
  }
  return 1;
}

/*---------------------------------

  auth

---------------------------------*/

export function emailSignIn(email, password) {
  return createUserWithEmailAndPassword(auth, email, password);
}

export function emailLogin(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
}

export function logout() {
  return signOut(auth);
}

export function authListen(func) {
  return onAuthStateChanged(auth, func);
}

export async function emailUpdate(newEmail, password) {
  try {
    await emailLogin(auth.currentUser.email, password);
  } catch (error) {
    return "credentialError";
  }
  return updateEmail(auth.currentUser, newEmail)
    .then(() => {
      return true;
    })
    .catch((error) => {
      return false;
      // An error ocurred
      // ...
    });
}

export function googleLogin() {
  const provider = new GoogleAuthProvider();
  signInWithRedirect(auth, provider);
}

export function anonymousSignin() {
  signInAnonymously(auth)
    .then(() => {
      // Signed in..
    })
    .catch((error) => {
      console.error(error);
      // ...
    });
}

export function connectAnonymousSignin() {
  const provider = new GoogleAuthProvider();
  linkWithRedirect(auth.currentUser, provider)
    .then((result) => {
      const credential = GoogleAuthProvider.credentialFromResult(result);
      linkWithCredential(auth.currentUser, credential)
        .then((usercred) => {
          const user = usercred.user;
        })
        .catch((error) => { });
    })
    .catch((error) => {
      // Handle Errors here.
      // ...
    });
}

export async function getIdToken() {
  const idTokenResult = auth.currentUser.getIdTokenResult(true);
  return idTokenResult;
}

export function verifyEmailByCode(actionCode) {
  return applyActionCode(auth, actionCode);
}

export function verifyPasswordByCode(actionCode, password) {
  return verifyPasswordResetCode(auth, actionCode)
    .then(() => {
      return confirmPasswordReset(auth, actionCode, password)
        .then((resp) => {
          return { result: 1 };
        })
        .catch((error) => {
          return { result: 0, error: "auth" };
        });
    })
    .catch((error) => {
      return { result: 0, error: "url" };
    });
}

export function verifyRecoverEmail(actionCode) {
  let restoredEmail = null;
  return checkActionCode(auth, actionCode)
    .then((info) => {
      restoredEmail = info["data"]["email"];
      return applyActionCode(auth, actionCode);
    })
    .then(() => {
      return { result: 1 };
    })
    .catch((error) => {
      return { result: 0, error: "url" };
    });
}

export function listenStore(path, setfixedUserInfo) {
  const docRef = doc(firestore, path);
  return onSnapshot(docRef, (gotDoc) => {
    setfixedUserInfo(gotDoc.data());
  });
}

export async function analyticsSetScreen(screenName, screenClass) {
  logEvent(analytics, "screen_view", {
    firebase_screen: screenName,
    firebase_screen_class: screenClass,
  });
}

export function getStorageUrl(path) {
  try {
    const res = getDownloadURL(storageRef(storage, path));
    return res;
  } catch (error) {
    return 0;
  }
}

export function getStorageBlob(path) {
  try {
    const res = getBlob(storageRef(storage, path));
    return res.then((blob) => {
      return blob.text();
    });
    // return res;
  } catch (error) {
    return 0;
  }
}

import { OAuthProvider } from "firebase/auth";

export const appleLogin = () => {
  const provider = new OAuthProvider("apple.com");
  signInWithRedirect(auth, provider).then((res) => { });
};

// const remoteConfig = getRemoteConfig(projApp);
// remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

export const getRemoteConfigValue = (key) => {
  remoteConfig.defaultConfig = {
    indicator_version: "v1",
    pair_version: "v1",
  };
  return fetchAndActivate(remoteConfig)
    .then((res) => {
      return getValue(remoteConfig, key);
      // ...
    })
    .catch((err) => {
      // ...
    });
};

export const uploadingImage = async (storagePath, file) => {
  const filename = idMaker(10);
  // const filename = imageSource.substring(imageSource.lastIndexOf('/') + 1);
  let path = [];
  // const storagePath = `${basePath}/${filename}`;
  const storageRefer = storageRef(storage, storagePath);
  return uploadBytes(storageRefer, file).then((snapshot) => {
    return getDownloadURL(snapshot.ref).then((downloadURL) => {
      path.push(downloadURL);
      return path;
    });
  });
};

export const deleteStorage = async (url) => {
  // const storageRefer = storageRef(storage, storagePath);
  const storageRefer = storageRef(storage, url);
  // Delete the file
  return deleteObject(storageRefer)
    .then(() => {
      return { result: 1 };
      // File deleted successfully
    })
    .catch((error) => {
      return { result: 0, error: error };
    });
};

export const uploadingImageBytes = (storagePath, file) => {
  const storageRefer = storageRef(storage, storagePath);
  const metadata = {
    cacheControl: "public,max-age=3600",
  };
  const uploadTask = uploadBytesResumable(storageRefer, file, metadata);
  return uploadTask;
};

export const getDownloadURLByStorage = async (ref, file) => {
  const downloadURL = await getDownloadURL(ref);
  return downloadURL;
};

export const errorHandler = (error, t = (v) => v) => {
  switch (error.code) {
    case "auth/invalid-email":
      return t("メールアドレスを確認してください");
    case "auth/invalid-password":
      return t("パスワードは6文字以上の長さが必要です");
    case "auth/wrong-password":
      return t("メールアドレスまたはパスワードが違います");

    case "auth/user-not-found":
      return t("登録されていません");

    case "auth/too-many-requests":
      return t("試行回数を超えました。時間を置いてください。");

    // register
    case "auth/email-already-in-use":
      return t("すでに登録されています");
    case "auth/email-already-exists":
      return t("すでに登録されています");

    case "auth/weak-password":
      return t("パスワードは6文字以上にしてください");

    default:
      return t("失敗しました");
  }
};

export function deleteAcount() {
  const user = auth.currentUser;
  return user
    .delete()
    .then(() => {
      window.alert("正常にアカウントが削除されました。");
      return { result: 1 };
    })
    .catch((err) => {
      if (
        !window.alert(
          "前回のログインから時間が経過しているため、アカウント削除できませんでした。一度ログアウトします。ログインしてから、再度お試しください。"
        )
      ) {
        logout();
      }
    });
}
